/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { BaseModalProps, colors, Markup, TextScreenModal } from '@blend/consumer-components';

import { ContextualHelpListItemModalContentWrapper } from './ContextualHelpListItemModalContentWrapper';

export namespace ContextualHelpListItemModal {
  export interface TextScreenDefinition {
    htmlText: string;
    title: string;
    /** Header in modal dialog. By default, the value is "Additional Help" */
    dialogHeader?: string;
  }

  export interface Props extends BaseModalProps {
    headerText?: string;
    textScreenDefinition?: TextScreenDefinition;
    textScreenId: string;
  }
}

export const ContextualHelpListItemModal: React.FC<ContextualHelpListItemModal.Props> = ({
  headerText,
  textScreenDefinition,
  textScreenId,
  ...modalProps
}) => {
  return (
    <TextScreenModal {...modalProps} headerText={textScreenDefinition?.dialogHeader} color={colors.reflex}>
      <ContextualHelpListItemModalContentWrapper>
        {textScreenDefinition && <Markup content={textScreenDefinition.htmlText} />}
      </ContextualHelpListItemModalContentWrapper>
    </TextScreenModal>
  );
};
